export function Divider (props) {
  return <hr {...props} />
}
